import axios from '../../plugins/axios';

export default {
    namespaced: true,

    state: {
        entities: [],
        entitiesCount: 0,
        entity: {}
    },

    mutations: {
        SET_ENTITIES(state, payload) {
            state.entities = payload.results;
            state.entitiesCount = payload.total;
        },
        SET_ENTITY(state, payload) {
            state.entity = payload;
        },
        CLEAR_ENTITY(state) {
            state.entity = {};
        },
    },

    actions: {
        async fetch({ commit }, { filter = {}, sorting = null, page = 1, itemsPerPage = 15 }) {
            const { data } = await axios.get('/admin/users', { params: { filter, sorting, page, itemsPerPage } });
            commit('SET_ENTITIES', data);
            return data;
        },
        async get({ commit }, { id }) {
            const { data } = await axios.get(`/admin/users/${ id }`);
            commit('SET_ENTITY', data);
        },
        async save({ commit, state }) {
            let response = {};
            if(state.entity.id) {
                response = await axios.put(`/admin/users/${ state.entity.id }`, state.entity);
            } else {
                response = await axios.post('/admin/users', state.entity);
            }
            return response.data;
        },
        async delete({ commit }, { id }) {
            await axios.delete(`/admin/users/${ id }`);
        },
    },

    getters: {}
}
